import { render } from "./BeneficiaryList.vue?vue&type=template&id=bf8484f6&scoped=true"
import script from "./BeneficiaryList.js?vue&type=script&lang=js&external"
export * from "./BeneficiaryList.js?vue&type=script&lang=js&external"

import "./BeneficiaryList.scss?vue&type=style&index=0&id=bf8484f6&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8484f6"]])

export default __exports__